/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Document, Image, Page, View} from '@react-pdf/renderer';
import React from 'react';
import {styles} from './styles';
import {AssurranceVoyage} from './assurranceVoyageWeb';

export const CpCgVoyage = (props: any) => {
  const {detailContrat} = props;
  return (
    <Document>
      {
        //CP voyage
      }
      <Page size="A4" style={styles.page}>
        <View style={styles.backgroundContainer}>
          <Image src={require('../../../../ressources/images/avenant_resiliation.png')} style={styles.backgroundImage} />
        </View>
        <View style={styles.contentContainer}>
          <AssurranceVoyage detailContrat={detailContrat} />
        </View>
      </Page>
    </Document>
  );
};
